
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vSwz", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

const $85a675280bdd34e2$var$styles = {
    dateWrapper: "_0bjKvDcjp5 _3vBAKHjOvk"
};
const $85a675280bdd34e2$export$19285a5b05c4ea7c = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { timestamp: timestamp } = t0;
    let t1;
    if ($[0] !== timestamp) {
        t1 = new Date(parseInt(timestamp)).toLocaleString("en-US", {
            timeZone: "Australia/Sydney"
        });
        $[0] = timestamp;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            backgroundColor: "color.background.neutral",
            padding: "space.025",
            testId: "data-component",
            xcss: $85a675280bdd34e2$var$styles.dateWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: t1,
            year: "numeric",
            month: "short",
            day: "numeric"
        }));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
module.exports["DateComponent"] = $85a675280bdd34e2$export$19285a5b05c4ea7c;

});


//# sourceMappingURL=DateComponent.6c1b7b11.js.map
